import * as yup from 'yup';


export const contactFormValidation = yup.object().shape({
    name:  yup.string().required('Please Enter Your Name'),
    phone: yup.number().required('Please Enter Your Mobile Number').min(10 , "Minimum 10 Numbers"),
    email: yup.string().email('Please Enter Valid Email').required('Email Address Required'),
})
